export default [
'c8f8ee19-3a88-40fa-85d8-386ffe06efd7',
'9e68dcc2-bba4-4efa-97bb-3ed892037595',
'b338e078-629c-4cac-bd1d-e1f0a132728d',
'e8fe855c-fe94-4de7-a033-9892a9d6ee0e',
'f4072640-0f9b-4f0a-84cc-eda415cc92e7',
'2569d4f3-55ed-4f99-9592-34c7df0aab72',
'08a5007f-06a0-40fa-a252-c38baa6b5c6f',
'd7501662-1216-4e08-bd2b-e0a459057942',
'3899605d-2203-4ab6-9ff5-69490382eea4',
'f0a9c72a-e450-41e3-80e5-06f2f1171245',
'e0f8e16a-55f0-4147-a01a-dba7938f31c4',
'284c4710-4183-4743-9c8b-515cc98cbbb8',
'62103ceb-b16d-48ea-af42-d3df88d1ee4c',
'864930ce-7c56-4ad2-9b90-57b10e5a0842',
'96916db2-5121-4ff1-880c-369744f11ecf',
'320fdf89-e158-41c5-b0bf-fee9dec36a75',
'cedd44eb-f381-46e1-bcb0-88416b4ce33d',
'eb6d8d1c-8d23-4273-9c9b-f3b71eb0e105',
'9e81806d-5d87-4032-ad94-c2cdeabecdbf',
'6a0b230b-d391-4998-a3f7-7b158a0ec2cd',
'19dbbecb-b4d0-49d2-b36e-58279e051c5c',
'eb11921b-1b28-483f-a707-4de21a6daa31',
'fd5be605-c7c3-4c0b-a68e-65452b27d3ce',
'75918859-c93f-41b4-9ad0-a4a96c389f0d',
'c4e4bbea-7e3f-4de0-bb01-dfd67f21c254',
'e112d77d-f019-4709-b31a-b02952df0e35',
'0a19da90-880e-4eca-8cf7-6d7baf090d53',
'430b96aa-7bb0-4d2b-b265-9c4987db28a2',
'ee7354fe-fb76-4196-a69b-0916af73bf45',
'6a26e910-275a-4981-831b-bfed936a7e3f',
'00d001d0-fd29-4b7c-9d0e-9131b995f910',
'6c957c94-3d2d-4b98-8990-cd8909462081',
'4686b51c-e02b-48c1-bafe-e8d08a5407b9',
'fa232c65-dbb4-4414-bd95-b3bbd321c653',
'c7a19fc5-20f3-48d2-8c12-e012d3b302e7',
'29d852c4-bd53-4a3b-b1e2-896917cbc27f',
'a5f30ecd-d009-4d44-aef4-c926ed55a521',
'77c6fa74-5543-42ac-9ead-0e890b188e99',
'b029eb9a-dd7a-40c2-96c4-0063d9cc002c',
'aba79021-39af-4e74-beb5-f2f508c865b2',
'bceab6b3-6b64-4964-a501-ce806a6c13ad',
'4c9c9b16-5567-4473-95e6-622292f77336',
'0cf8cb1e-314a-4894-82df-f9812825f52e',
'b5545882-6963-4729-b2c6-fb4bdc75ffcc',
'a0ab67cc-b553-4451-9cda-0e5fe3303940',
'5ed81ee8-d5e4-4127-876e-9bff81f9c726',
'6203e3d4-8998-41d6-9f7e-b68af0f1f8b5',
'34c3a894-ee75-4db9-a69f-711bb3cc150a',
'dd29a0e5-c1de-4e8a-8866-715e9f9cde1f',
'b0e0ef27-3db2-4976-b9db-13e3d7cd795d',
'5f1cdcba-a04a-4a2f-8bc1-0dd7fa03754d',
'b1f73271-b70f-40ae-be64-f8de7805923a',
'dff51ae7-4b68-4770-915b-fb6bcf9ca1ed',
'305078a5-ac18-4721-bba2-3434eba5b1cf',
'b299c599-1a10-4122-ac0b-8f52a9cec7b6',
'b2991802-e313-40de-b167-0ede5efff101',
'7a6b087b-a3ac-4c4d-a519-ec5584b4b42d',
'd479ca28-bdc2-4b87-abf7-5aeb229a3f1e',
'1ab6ffe8-e1ad-4db9-98f7-d6038f271866',
'c25df202-0dd4-448d-8cb3-11fd7df0d505',
'3d69a3e0-6a2e-475a-964e-0affed1c017d',
'2f48df6c-8d5d-4d8a-b98a-793f6a56184d',
'5f27dbf0-6818-40ea-832d-10686b4c2900',
'4b332e3d-dcf4-4f62-8130-124ec5d23b90',
'7165a9ac-3f44-4d14-93bb-d4d4970ab41b',
'4d5be4ab-f85a-4272-ac08-99cb0105eb11',
'26bfde99-7761-48e1-851a-522f888d0f6c',
'a82559e5-110b-4c6a-956a-7cba83788dc8',
'a5e19147-e459-43a6-8ef0-e37968a462e3',
'2dd6977e-269a-4cd1-99ad-37846a0647a7',
'f87e5072-525e-4b0b-a5c3-ee5e89a81e1d',
'7b3543e0-c15f-4fed-9a68-8f590b40ab16',
'1aeb6b3a-1e84-4181-9e7f-d5a88ebf08b1',
'fb4c5dd4-79dc-4bd2-8c18-897924a4a959',
'93aba9d5-5f96-4aba-8248-74398b8bfe9d',
'9c9ac1bc-cdf3-4fa6-8319-a7ea164e9e47',
'889a92ca-e198-494d-9ccb-6ae2c19ec62e',
'd0957032-6d98-4cac-889b-890e9bfe1f86',
'47a929a4-b861-432c-a2f3-3125f8a2665b',
'03aff125-8962-4a0a-a2b4-e5d693b75400',
'9695f390-f791-4d64-90b2-731d6d37df1c',
'5da7739e-8413-45b6-8539-fde2021b06a7',
'a9861fb3-6722-43b8-bf0a-af6dd166e59d',
'edfbf056-c3b7-40e9-8e2b-333585978ac9',
'c289baab-04ee-4639-bc9b-9f032752fa69',
'0784b6f0-9ebf-43d2-ba0f-a6bc93ba0c48',
'0d26c559-ad06-4f78-b7b6-e658be8c7bdb',
'62f99124-6595-45f8-bece-1775e4c55a5c',
'86d6b411-4a31-4bfc-8dd6-e19f553bb29b',
'd072e9ca-aae7-45dc-8025-3ce590bae63f',
'390c40ba-2464-44ae-8d67-93c72ab3c425',
'4f616706-ec97-4923-bb1e-11a69fbaa1f8',
'7ac43e16-8b14-46f2-877a-600ea918766b',
'179236d9-6fe2-4db6-bdfb-f851e8d531a2',
'95f27eeb-6f14-4db3-adb9-9be5ed76b34b',
'2f5b12f0-986f-43d0-a81b-64111e7f17e6',
'77f1f6ac-983f-4f3e-8906-47f774e8367b',
'77192bdf-d89f-45a1-a30b-20107e990031',
'683c4e13-525c-45c9-8832-bfe67965c34e',
'2db7a0e6-eea5-4fa6-ac14-401411b106cc',
'42663ac9-6b77-44f5-be76-c2c52d8465fc',
'1ad9ba08-91e7-4811-bf19-bc7076d3cf3c',
'bf9fecfd-d122-422f-bd0a-5bf69b434dfe',
'f85ab5f9-508e-45de-8fa1-ce1f16552ffc',
'ec3de5f4-bb55-4ab9-995f-f3e0dc22c1bb',
'f3537373-ef54-4578-9d05-6216420ee349',
'39704000-65d3-4d39-849e-a3b617376bbc',
'cfdb1c47-14be-491f-88b3-bed03489dbc5',
'ee6e5a35-fe21-4dee-b0ef-a8f2841511ad',
'56001a36-126b-4c08-af98-a6cc4d84210e',
'a24b4cb6-cebb-428b-8654-74347a6a8d63',
'1c2b13b1-31f0-4676-88a7-53f3a190e9a2',
'b18fe7e0-8344-40cc-b242-83f01c6be7a6',
'a8e328c6-3a84-49cf-a1a3-1d1e5373d274'
]

/*
error cards
'7b8197b9-0cd1-4fa1-9668-d1b5f1759151'
'b70fbe1c-d3f4-4e28-a830-2072dee1b7b5'
'438e3302-daf9-436b-8b08-24b3f33295f6'
'6904ea20-e504-47da-95a0-08739fdde260'
*/